export default __webpack_public_path__ + "fc2ca3f8117254b49748e4589865a57c.webp";